import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FaviconService } from "./services/style/favicon.service";
import { AlertComponent } from "./components/alerts/alert.component";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, AlertComponent],
  template: `
    <router-outlet></router-outlet>
    <app-alert></app-alert>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  protected readonly faviconService = inject(FaviconService);
}
